<template>
  <div class="sync-data-list">
    <div class="d-flex justify-content-between align-items-center sync-data-list__header">
      <div>
        <div class="sync-data-list__title fw-bold">Danh sách tài khoản Cloud</div>
        <div class="sync-data-list__description">
          Đồng bộ hình ảnh, video và file trò chuyện sang Salework Cloud.
        </div>
      </div>
      <el-input
        v-model="searchKey"
        clearable
        size="small"
        prefix-icon="el-icon-search"
        placeholder="Tìm theo tên, biệt danh hoặc số điện thoại"
        class="sync-data-list__search" />
    </div>

    <el-table
      :data="viewAccount"
      row-key="accountId"
      border
      size="small"
      class="sync-data-table"
      empty-text="Không có dữ liệu">
      <el-table-column label="Tài khoản" min-width="220">
        <template slot-scope="scope">
          <div class="sync-account-cell">
            <el-avatar :src="scope.row.avatar" :size="32"></el-avatar>
            <div class="sync-account-info">
              <div class="sync-account-name">{{ scope.row.displayName }}</div>
              <div v-if="scope.row.swName" class="sync-account-alias">
                Biệt danh: {{ scope.row.swName }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Cuộc trò chuyện" min-width="180">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.conversationType"
            size="small"
            class="w-100"
            @change="activeChange(scope.row)">
            <el-option
              v-for="item in conversationTypes"
              :key="item.val"
              :label="item.name"
              :value="item.val" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="Nội dung" min-width="170">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.contentType"
            size="small"
            class="w-100"
            @change="activeChange(scope.row)">
            <el-option
              v-for="item in contentTypes"
              :key="item.val"
              :label="item.name"
              :value="item.val" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="Kích hoạt" width="120" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.active" @change="activeChange(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "CloudSetting",
  data() {
    return {
      searchKey: "",
      accounts: [],
      statusAccount: "",
      conversationTypes: [
        { name: "Tất cả liên hệ", val: "all" },
        { name: "Cá nhân", val: "personal" },
        { name: "Nhóm", val: "group" }
      ],
      contentTypes: [
        { name: "Tất cả", val: "all" },
        { name: "Hình ảnh", val: "image" },
        { name: "File", val: "file" }
      ]
    };
  },
  computed: {
    viewAccount() {
      const keyword = this.normalizeSearchText(this.searchKey);
      const phoneKeyword = this.normalizePhoneText(this.searchKey);
      if (!keyword) return this.accounts;

      return this.accounts.filter(account => {
        return [
          account.displayName,
          account.swName,
          account.phoneNumber,
          account.phone
        ].some(value => {
          const normalizedValue = this.normalizeSearchText(value);
          const normalizedPhone = this.normalizePhoneText(value);
          return normalizedValue.includes(keyword)
            || (phoneKeyword && normalizedPhone.includes(phoneKeyword));
        });
      });
    }
  },
  methods: {
    activeChange(account) {
      this.$http.post("/api/cloud/save", account);
    },
    normalizeSearchText(value) {
      return (value || "")
        .toString()
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d");
    },
    normalizePhoneText(value) {
      const phone = (value || "").toString().replace(/\D/g, "");
      if (phone.startsWith("840")) return "0" + phone.substring(3);
      if (phone.startsWith("84")) return "0" + phone.substring(2);
      return phone;
    },
    getAll() {
      this.accounts = [];
      this.$http.get("/api/cloud/setting").then((res => {
        res.data.forEach((a) => {
          let acc = this.app.accounts.filter((f) => f.accountId == a.accountId);
          if (acc != null && acc.length > 0) {
            a.displayName = acc[0].displayName;
            a.swName = acc[0].swName;
            a.avatar = acc[0].avatar;
            a.phoneNumber = acc[0].phoneNumber;
            a.phone = acc[0].phone;
            if (!a.contentType) {
              a.contentType = "all";
            }
            if (!a.conversationType) {
              a.conversationType = "all";
            }
            this.accounts.push(a);
          }
        });
      }));
    }
  },
  created() {
    this.getAll();
  }
};
</script>

<style scoped>
.sync-data-list {
  background: #ffffff;
  border: 1px solid #dcdfe9;
  border-radius: 8px;
  padding: 12px;
}

.sync-data-list__title {
  color: #202125;
  font-size: 16px;
}

.sync-data-list__description {
  color: #696b72;
  font-size: 14px;
  margin-top: 4px;
}

.sync-data-list__header {
  gap: 12px;
  margin-bottom: 12px;
}

.sync-data-list__search {
  max-width: 360px;
}

::v-deep .sync-data-table {
  font-size: 14px;
}

::v-deep .sync-data-table th {
  color: #696b72;
  font-size: 14px;
  font-weight: 700;
}

.sync-account-cell {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.sync-account-info {
  min-width: 0;
}

.sync-account-name {
  color: #202125;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sync-account-alias {
  color: #d93025;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .sync-data-list__header {
    align-items: stretch !important;
    flex-direction: column;
  }

  .sync-data-list__search {
    max-width: none;
  }
}
</style>
